export const IconArrowDown = ({
	scheme,
	width,
	height,
	sx,
	rotated,
}: {
	width?: string;
	height?: string;
	scheme?: "light" | "dark";
	rotated?: boolean;
	sx?: React.CSSProperties;
}) => {
	const color = !scheme || scheme === "light" ? "#1C2E45" : "#FFFFFF";

	return (
		<svg
			style={{ ...sx, transition: "all .2s", transform: rotated ? "rotate(180deg)" : "rotate(0deg)" }}
			width={width ?? "24"}
			height={height ?? "24"}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path d="M17 9V11L12 16L7 11V9L12 14L17 9Z" fill={color} fillOpacity="0.6" />
		</svg>
	);
};
